export default "__VITE_ASSET__bp0vUr5B__"